module.exports = {"version":8,"glyphs":"%REPLACE_LB%/tileservergl/fonts/{fontstack}/{range}.pbf","sources":{},"layers":[]}